import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="35c23whp4t7xc">
      <Routes data-id="element-1" data-mp="3k9ktfm9mvp5u">
        <Route path="/" element={<LandingPage data-id="element-3" data-mp="3k8jgtdcyyum0" />} data-id="element-2" data-mp="3k9b5e485fs2s" />
      </Routes>
    </BrowserRouter>;
}